import { EAdditionalDriverInfo } from "./LanguagePack/translatedFields";
import { Box } from "@mui/material";
import { ContractField } from "./common";

export default function ContractAdditionalDriverInformation({
  visibility,
  selectedLanguage,
  contractSettings,
}) {
  const fields = EAdditionalDriverInfo[selectedLanguage];

  if (visibility)
    return (
      <Box
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "5px",
          paddingBottom: "5px",
        }}
      >
        <ContractField
          value={""}
          label={fields.TITLE}
          visibility={!!contractSettings?.showAdditionalDriver}
        />
      </Box>
    );
}
